import UserTable from "@/components/UserTable";
import { useGeneralApiCall } from "@/services/useGeneralApiCall";
import { User } from "@/types";
import { useEffect, useState } from "react";
import LoadingComponent from "@/components/Loading";
import { Alert } from "react-bootstrap";

function UsersPage() {
  const { getApi, loading, error } = useGeneralApiCall();
  const [data, setData] = useState<User[]>([]);

  type UserListResponse = User[];

  const getData = async () => {
    await getApi<UserListResponse>("/api/auth/v1/staff/list").then((res) => {
      console.log(res.data)
      setData(res.data);
    });
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      {loading ? (
        <LoadingComponent />
      ) : error ? (
        <Alert variant="danger">{error}</Alert>
      ) : (
        <UserTable data={data} setData={setData} getData={getData} />
      )}
    </>
  );
}

export default UsersPage;
